export default __webpack_public_path__ + "static/media/EESymbolsImg8.6f821fe0.jpg";